var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-container"}},[_vm._m(0),_c('application',{staticStyle:{"margin-bottom":"80px"},attrs:{"id":"app"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tetra-logo"}},[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":require("./assets/logo.png")}})])
}]

export { render, staticRenderFns }